import { Box, Flex, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { EmptyListIcon } from '../../icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NoData = function NoData() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/_jsxs(Box, {
    py: "6",
    e2eid: "common_NoData_Box",
    children: [/*#__PURE__*/_jsx(Flex, {
      justify: "center",
      e2eid: "common_NoData_Flex",
      children: /*#__PURE__*/_jsx(EmptyListIcon, {
        e2eid: "common_NoData_EmptyListIcon"
      })
    }), /*#__PURE__*/_jsx(Flex, {
      justify: "center",
      my: "2",
      color: "#B9B9C3",
      e2eid: "common_NoData_Flex",
      children: /*#__PURE__*/_jsx(Text, {
        fontSize: "16px",
        color: "#B9B9C3",
        e2eid: "common_NoData_Text",
        children: t('common:table.noData', '尚無資料')
      })
    })]
  });
};
export default NoData;